
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerCardModel } from '../models/CustomerCardModel';

interface LinkToClientProps {
    customer: any;
}

const LinkToClient = (props: LinkToClientProps) => {

    const navigate = useNavigate();
    const customerCardModel: CustomerCardModel = new CustomerCardModel();

    const goToClient = async () => {
        // localStorage.setItem('leadId', props.clientId);
        console.log('goToClient', props.customer);
        const customerDataResult = await customerCardModel.getCustomerCardDetails(props.customer.id);
        console.log('goToClient-customerDataResult', customerDataResult);
        const customerDetails = customerDataResult.personalData.customerData;
        
        const tabsForSave: any[] = [];
        const tContent: any = {
            type: "editCustomer",
            title: customerDetails.fullName,
            id: customerDetails.id,
            mode: 1,
            editData: undefined,
            loaded: false
        }
        tabsForSave.push(tContent);
        localStorage.setItem('clientsOpenTabs', JSON.stringify(tabsForSave));

        navigate(`/Clients/`);
    
    }
    return (

        <li className="action-btn-menu-item pointer"
            onClick={() => { goToClient() }}
        >
            תיק לקוח
        </li>

    )
}

export default LinkToClient